<app-nav titulo="Detalles del agente" descripcion="Aqui podrá ver toda la información que tenemos acerca del agente seleccionado.">
    <div class="broker-details">
        <app-broker-details-content [broker]="broker" *ngIf="broker"></app-broker-details-content>
    </div>
</app-nav>
